import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { MenuComponent } from './menu/menu.component';
import { LoginComponent } from './login/login.component';
import { IndexComponent } from './index/index.component';

const routes: Routes = [

    { path: 'cars', component : MenuComponent }, 
    { path: '', component : IndexComponent }

];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    declarations : [],
})
export class LayoutRoutingModule {}



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/layout/layout.routing.ts